(function () {
  'use strict';

  const owner = Symbol.for('aoctant.footer');
  if (document[owner]) return;
  document[owner] = true;

  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const desktopMenu = window.matchMedia('(min-width: 768px)');
  const instances = new Map();

  function mount(footer) {
    instances.get(footer)?.();
    const controller = new AbortController();
    const { signal } = controller;
    const animations = new Set();
    const inner = footer.querySelector('.aoctant-footer__inner');
    const main = footer.querySelector('.aoctant-footer__main');
    const value = Number(footer.dataset.parallaxStrength ?? 40);
    const strength = Math.min(80, Math.max(0, Number.isFinite(value) ? value : 40)) / 100;
    let frame = 0;

    function update() {
      frame = 0;
      footer.classList.toggle('aoctant-footer--reduced-motion', motion.matches);
      if (!inner || !main) return;
      if (motion.matches || !footer.classList.contains('aoctant-footer--parallax')) {
        inner.style.removeProperty('--aoctant-footer-reveal');
        return;
      }
      const rect = main.getBoundingClientRect();
      const range = Math.max(1, Math.min(rect.height, window.innerHeight));
      const progress = Math.min(1, Math.max(0, (window.innerHeight - rect.top) / range));
      inner.style.setProperty('--aoctant-footer-reveal', (-(1 - progress) * rect.height * strength).toFixed(1) + 'px');
    }

    function request() {
      if (!frame) frame = requestAnimationFrame(update);
    }

    const menuGroups = footer.querySelectorAll('.aoctant-footer__menu-group');
    const syncMenuState = () => {
      menuGroups.forEach(group => {
        group.open = desktopMenu.matches || !group.classList.contains('aoctant-footer__menu-group--customer-care');
      });
    };

    syncMenuState();
    desktopMenu.addEventListener('change', syncMenuState, { signal });

    menuGroups.forEach(group => {
      const summary = group.querySelector('.aoctant-footer__menu-heading');
      const content = group.querySelector('.aoctant-footer__menu-content');
      if (!summary || !content) return;
      let animation = null;
      let opening = group.open;

      const settle = () => {
        if (animation) {
          animation.cancel();
          animations.delete(animation);
          animation = null;
          group.open = opening;
        }
      };

      summary.addEventListener('click', event => {
        if (window.innerWidth >= 768) return;
        event.preventDefault();
        const from = group.open ? content.getBoundingClientRect().height : 0;
        opening = animation ? !opening : !group.open;
        settle();
        if (motion.matches) {
          group.open = opening;
          return;
        }
        group.open = true;
        animation = content.animate(
          [{ height: from + 'px', overflow: 'hidden' }, { height: (opening ? content.scrollHeight : 0) + 'px', overflow: 'hidden' }],
          { duration: 250, easing: 'ease' }
        );
        animations.add(animation);
        animation.onfinish = settle;
      }, { signal });
      window.addEventListener('resize', settle, { signal });
      motion.addEventListener('change', settle, { signal });
    });

    if (footer.classList.contains('aoctant-footer--parallax')) {
      document.addEventListener('scroll', request, { passive: true, capture: true, signal });
      window.addEventListener('resize', request, { signal });
    }
    motion.addEventListener('change', update, { signal });
    update();

    instances.set(footer, () => {
      controller.abort();
      if (frame) cancelAnimationFrame(frame);
      animations.forEach(animation => animation.cancel());
      inner?.style.removeProperty('--aoctant-footer-reveal');
      instances.delete(footer);
    });
  }

  function init(root = document) {
    if (root instanceof Element && root.matches('.aoctant-footer')) mount(root);
    root.querySelectorAll('.aoctant-footer').forEach(mount);
  }

  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [footer, cleanup] of instances) {
      if (event.target === footer || event.target.contains(footer)) cleanup();
    }
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }
})();
